/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_Chip_GroupInputs */

const en_platform_hero_chip_group = /** @type {(inputs: Platform_Hero_Chip_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRX group`)
};

const pl_platform_hero_chip_group = /** @type {(inputs: Platform_Hero_Chip_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupa TRX`)
};

/**
* | output |
* | --- |
* | "TRX group" |
*
* @param {Platform_Hero_Chip_GroupInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_chip_group = /** @type {((inputs?: Platform_Hero_Chip_GroupInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_Chip_GroupInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_chip_group(inputs)
	return en_platform_hero_chip_group(inputs)
});